import { render } from "./HeroTravelStatus.vue?vue&type=template&id=22839991&scoped=true"
import script from "./HeroTravelStatus.vue?vue&type=script&lang=js"
export * from "./HeroTravelStatus.vue?vue&type=script&lang=js"

import "./HeroTravelStatus.vue?vue&type=style&index=0&id=22839991&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22839991"]])

export default __exports__